// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__-qZ3Q","signatureButtonsRight":"ModalSign_signatureButtonsRight__3PdUZ"};